<template>
    <div class="relative pb-8" :style="{marginBottom: errorHeight+'px'}">
        <slot v-if="reverseLabel && !inline"></slot>
        <Label v-if="$slots.label || label" :inline="inline" :required="required">
            <slot v-if="reverseLabel && inline"></slot>
            <span
                class="inline-block"
                :class="[
                    reverseLabel ? 'ml-2' : 'mb-1',
                    {'text-red-500': errorMessage}
                ]">
                <slot name="label">{{ label }}</slot>
                <slot v-if="!reverseLabel && inline"></slot>
            </span>
        </Label>
        <slot v-if="!reverseLabel && !inline"></slot>

        <InputError v-if="showError" ref="error" :data-name="name" class="absolute mt-1" :message="errorMessage"/>
    </div>
</template>

<script>

import Label from "@/Components/Form/Label.vue";
import InputError from "@/Components/Form/InputError.vue";
import {computed} from "vue";
import {debounce, get} from "lodash";

export default {

    name: "FormGroup",

    props: {
        label: String,
        error: String,
        name: String,
        showLabelAfter: {
            default: false
        },
        showError: {
            default: true
        },
        required: {
            type: Boolean,
            default: false
        },
        inline: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            errorHeight: 0
        };
    },

    components: {
        Label,
        InputError,
    },

    inject: ['form'],

    provide() {
        return {
            hasError: computed(() => !!this.errorMessage)
        };
    },

    mounted() {
        window.addEventListener('resize', debounce(() => {
            this.setErrorHeight();
        }, 200));
    },

    methods: {
        setErrorHeight() {
            if (!this.$refs.error) {
                return;
            }

            const height = this.$refs.error.$el.clientHeight - 21;
            this.errorHeight = height > 0 ? height : 0;
        }
    },

    computed: {
        reverseLabel() {
            if (this.inline) {
                return true;
            }

            return this.showLabelAfter;
        },
        errorMessage() {
            if (!this.showError) {
                return false;
            }
            if (this.error) {
                return this.error;
            }

            if (this.form && this.name) {
                return this.form.getError(this.name);
            }
        },
        value() {
            if (this.form && this.name) {
                return get(this.form, this.name);
            }
        }
    },

    watch: {
        value() {
            if (this.form.errors.errors.hasOwnProperty(this.name)) {
                this.form.errors.clear(this.name);
            }
        },
        errorMessage() {
            this.$nextTick(this.setErrorHeight);
        }
    },

    beforeUnmount() {
        window.removeEventListener('resize', debounce(() => {
            this.setErrorHeight();
        }, 200));
    }
};

</script>
